import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function TourAlbum2025() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            本社見学2025年
          </Typography>
          <Box my={4}>
            <Paper>
              <Grid className="p-3" spacing={4} container direction="row" justify="left">

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251210_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町立百石小５年松組のみなさん（2025/12/10）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251126_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          七戸町立城南小５年生のみなさん（2025/11/26）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251118_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸商工会議所女性会のみなさん（2025/11/18）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251112_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          洋野町立帯島小５年生のみなさん（2025/11/12）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251107_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          五戸町立切谷内小５、６年生のみなさん（2025/11/07）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
                
                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251007_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          東北町立甲地小５年生のみなさん（2025/10/07）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img251002_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市鴎盟大学32期会のみなさん(2025/10/02)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250930_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町・七軒町町内会のみなさん(2025/09/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250919_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          岩手労働基準協会盛岡支部のみなさん(2025/09/19)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250917_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市医師会のみなさん(2025/09/17)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250711_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          久慈市立小袖小５、６年生のみなさん(2025/07/11)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250613_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          五戸町立倉石小５年生のみなさん(2025/06/13)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250218_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立白銀小５年生のみなさん(2025/02/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2025/k_img250120_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町・木内々ほのぼの交流協力員のみなさん(2025/01/20)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

              </Grid>
            </Paper>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default TourAlbum2025;
